<template>
    <div class="downloadProgressDialog">
        <el-dialog :title="myTitle" width="400px"  :visible.sync="dialogVisible" :close-on-click-modal="false">
          <div style="text-align: center;">
            <el-progress :percentage="percentage" type="circle"></el-progress>
          </div>
          <span style="color: red;" v-show="type == 'baidu' && percentage == 0">数据处理中，请耐心等待</span>
          <div style="text-align: center;" v-if="totalSize > 0">
            {{downSize | unitM}}/{{totalSize | unitM}}M
          </div>
            <div slot="footer" class="dialog-footer">
              <!-- 原始下载 -->
              <el-button type="primary" :loading="loading" :disabled="loading" @click="download">下载</el-button>
               <!-- 比对下载途径 -->
              <!-- <el-button type="primary" :loading="loading" :disabled="loading" @click="downCheck">下载</el-button> -->
              <el-button @click="cancel">隐藏</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import * as simpleApi from "request/simple";
    import XEUtils from 'xe-utils'
    import * as mUtils from '@/utils/mUtils'
    import axios from "axios";

    export default {
        name: 'downloadProgressDialog',
        data(){
            return {
                formLabelWidth: '120px', myTitle: '正在下载，请等待', percentage: 0,
                dialogVisible:false, loading: false, totalSize: 0,  downSize: 0,
                examId: null,
                type: null
            }
        },
        components:{
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            })
        },
      	mounted() {
	    },
      filters:{
        unitM: function (v){
          if (typeof v === 'number') {
            return ( v/1024/1024).toFixed(2)
          }
        }
      },
        props: {
            downUrl: {
                type: String
            },
          downFileName: {
            type: String
          }
        },
        watch: {

        },
        methods: {
          // 下载前校验，判断文件存在在服务器或百度云盘
          downCheck(){
            let param = { controllerName: 'exam/', methodName: '/downUrlCheck', param: {examId: this.examId}};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                   if(data) {
                    this.download()
                    this.type = 'url'
                   }else{
                    this.download_baidu()
                    this.type = 'baidu'
                    // this.test()
                   }
                }).catch((error) => {
                    
                });
          },
          download() {
            let that = this
            this.loading = true
            this.myTitle = '正在下载，请等待';
            //进度条恢复为 0
            this.percentage= 0;
            //发起请求
            axios.defaults.headers = {'Content-Type': 'application/json; application/octet-stream'}
            axios({
              url: this.downUrl,
              method:"get",
              responseType:"blob",
              params:{},
              //xml返回数据的钩子函数，可以用来获取数据的进度 具体可查看axios的官网
              onDownloadProgress:(progressEvent)=>{
                //progressEvent.loaded 下载文件的当前大小
                //progressEvent.total  下载文件的总大小 如果后端没有返回 请让他加上！
                this.downSize = progressEvent.loaded
                this.totalSize = progressEvent.total
                let progressBar = Math.round( progressEvent.loaded / progressEvent.total*100);
                //接收进度为99%的时候需要留一点前端编译的时间
                if(progressBar >= 99){
                  this.percentage = 99;
                  // this.$message.success("下载完成，文件正在编译。");
                  // this.title = '下载完成，文件正在编译。';
                }else{
                  this.percentage = progressBar;
                  // this.$message("正在下载，请稍等。");
                  // this.title = '正在下载，请稍等。';
                }
                that.loading = true
                // console.log(progressEvent)
              }
            }).then(res => {
              // console.log(res)
              if(res.status != 200){
                this.$message.error("文件下载失败"+res.status+"，请稍后重试！");
                this.loading = false
                return false;
              }
              //blob返回的是一个 base64 格式的文件流
              let blob = new Blob([res.data],{
                //编译文件为xlsx类型。 具体可查看 blob 方法定义的类型
                type:"application/zip"
              })
              //编译文件
              if(window.navigator && window.navigator.meSaveOrOpenBlob){
                window.navigator.meSaveOrOpenBlob(blob,that.downFileName)
              }else{
                // 非ie的下载
                const link = document.createElement('a');
                const body = document.querySelector('body');
                link.href = window.URL.createObjectURL(blob);
                link.download = that.downFileName; // 下载的文件名
                // fix Firefox
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
              }
              //编译文件完成后，进度条展示为100%100
              this.percentage =100;
              this.dialogVisible = false; // 关闭进度条显示层
              this.loading = false
            }).catch(err=>{
              this.myTitle = '文件下载失败';
              that.loading = false
            })
          },
          download_baidu(){
            let that = this
            this.loading = true
            this.myTitle = '正在下载，请等待';
            //进度条恢复为 0
            this.percentage= 0;
            axios.get('http://127.0.0.1:9999/python/download', 
            {
              params:{
                examId: this.examId
              },
              responseType: 'blob', // 必须指定响应类型为blob
              onDownloadProgress: progressEvent => {
              
                this.downSize = progressEvent.loaded
                this.totalSize = progressEvent.total
                // 计算下载进度
                const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                // console.log(`下载进度: ${percent}%`);
                // 可以更新页面上的进度条
                // document.getElementById('progress').innerText = `下载进度: ${percent}%`;
                
                //接收进度为99%的时候需要留一点前端编译的时间
                if(percent >= 99){
                    this.percentage = 99;
                    // this.$message.success("下载完成，文件正在编译。");
                    // this.title = '下载完成，文件正在编译。';
                  }else{
                    this.percent = percent;
                    // this.$message("正在下载，请稍等。");
                    // this.title = '正在下载，请稍等。';
                  }
                  that.loading = true
                  // console.log(progressEvent)

              }
            })
            .then(response => {
   
              const blob = new Blob([response.data]);
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = that.downFileName
              a.click();

              //编译文件完成后，进度条展示为100%100
              this.percentage =100;
              this.dialogVisible = false; // 关闭进度条显示层
              this.loading = false

              // 下载后触发删除
              // this.test()
            })
            .catch(error => {
              this.myTitle = '文件下载失败';
              that.loading = false
              console.error('下载失败:', error);
            });
          },
          test(){
            axios.get('http://localhost:9999/python/remove_file',{
              params:{
                examId: this.examId
              },
            })
            .then(response => {
              console.log(response.data);
              // 处理数据
            })
            .catch(error => {
              console.error('Error fetching data:', error);
            });
          },

            showDialog(){
              this.loading = false
              this.myTitle = '请点击下载';
              this.percentage= 0;
                this.dialogVisible = true;
            },
            hideDialog(){
                this.dialogVisible = false;
            },
            cancel(){
                this.dialogVisible = false;
                this.$emit('cancel');
            },
            handleClose(index){
              let d = this.selectList[index]
              this.tichuChange({id: d.id, is_tichu: false })
              this.selectList.splice(index, 1);
            },

        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .downloadProgressDialog{

    }


</style>


